import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Button, IconButton, Paper, Tooltip, Typography } from '@material-ui/core';
import { Close, Delete, DeleteForever, Edit, Folder, Forward, InsertDriveFile } from '@material-ui/icons';
import { formatDate } from '@sierralabs/core';
import { CardTitle } from '@sierralabs/core-ui';
import { useTaskFields } from '@sierralabs/workflow-ui';
import DocumentDeleteDialog from '../dialogs/DocumentDeleteDialog';
import DocumentRenameDialog from '../dialogs/DocumentRenameDialog';
import { useDocumentListPageContext } from '../DocumentListPageContext';
import DocumentInfoDrawerTabPanel from './DocumentInfoDrawerTabPanel';
const StyledDocumentInfoDrawer = styled(Paper) `
  display: flex;
  flex-direction: column;
  width: 320px;
  border-radius: 0;
  transition: all 300ms;
  &.closed {
    margin-right: -320px;
  }
  .info-header {
    background: #f1f3f3;
    color: #5a5a5a;
    .header-label {
      flex: 1;
      font-size: 14px;
      margin-left: 4px;
    }
    .file-info {
      padding: 0 20px;
      .file-actions {
        display: flex;
        padding: 10px 0;
        align-items: center;
        .align-right {
          flex: 1;
          display: flex;
          justify-content: flex-end;
        }
        button,
        .btn-container {
          margin-right: 10px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
`;
const DocumentInfoDrawer = props => {
    var _a;
    const { open, file, onMove, onClose, onSuccess } = props;
    const { isFolder } = file;
    const history = useHistory();
    const { basePath, toFilePath } = useDocumentListPageContext();
    const [isOpenRenameDialog, setIsOpenRenameDialog] = useState(false);
    const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false);
    const { isFieldDisabled } = useTaskFields(file.task, !isFolder);
    const isTrash = file.name === 'Trash' && !!file.isLocked;
    const isDisabled = file.isLocked || isFieldDisabled('name');
    const isEditable = !isTrash && (isFolder || !isDisabled);
    // clear state
    useEffect(() => {
        if (!open) {
            setIsOpenRenameDialog(false);
            setIsOpenDeleteDialog(false);
        }
    }, [open]);
    return (React.createElement(StyledDocumentInfoDrawer, { className: open ? 'open' : 'closed' },
        React.createElement("header", { className: 'info-header' },
            React.createElement(CardTitle, null,
                file.isFolder ? React.createElement(Folder, null) : React.createElement(InsertDriveFile, null),
                React.createElement("span", { className: 'header-label' },
                    file.isFolder ? 'Folder' : 'File',
                    " Info"),
                React.createElement(IconButton, { size: 'small', onClick: onClose },
                    React.createElement(Close, null))),
            React.createElement("div", { className: 'file-info' },
                React.createElement(Typography, { variant: 'h6' }, file.name),
                React.createElement("div", { className: 'modified-date' }, formatDate(file === null || file === void 0 ? void 0 : file.modified)),
                React.createElement("div", { className: 'file-actions' },
                    React.createElement("div", { className: 'align-left' },
                        React.createElement(Button, { variant: 'outlined', onClick: () => {
                                const path = file.isFolder
                                    ? `${basePath}/folder/${file.id}`
                                    : toFilePath(file.id);
                                history.push(path);
                            } }, "Open")),
                    React.createElement("div", { className: 'align-right' },
                        React.createElement(Tooltip, { title: isEditable
                                ? 'Rename'
                                : isTrash
                                    ? 'Cannot rename the Trash folder'
                                    : 'Cannot rename on this status' },
                            React.createElement("span", { className: 'btn-container' },
                                React.createElement(IconButton, { size: 'small', disabled: !isEditable, onClick: () => setIsOpenRenameDialog(true) },
                                    React.createElement(Edit, null)))),
                        React.createElement(Tooltip, { title: 'Move' },
                            React.createElement("span", { className: 'btn-container' },
                                React.createElement(IconButton, { size: 'small', onClick: onMove, disabled: file.isLocked },
                                    React.createElement(Forward, null)))),
                        React.createElement(Tooltip, { title: 'Delete' },
                            React.createElement("span", { className: 'btn-container' },
                                React.createElement(IconButton, { size: 'small', disabled: file.isLocked, onClick: () => setIsOpenDeleteDialog(true) }, ((_a = file.path) === null || _a === void 0 ? void 0 : _a.startsWith('Trash/')) ? (React.createElement(DeleteForever, null)) : (React.createElement(Delete, null))))))))),
        React.createElement(DocumentInfoDrawerTabPanel, { file: file }),
        React.createElement(DocumentRenameDialog, { file: file, open: isOpenRenameDialog, onCancel: () => setIsOpenRenameDialog(false), onSuccess: updatedFile => {
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(`${file.name} renamed to ${updatedFile.name}`);
            } }),
        React.createElement(DocumentDeleteDialog, { file: file, open: isOpenDeleteDialog, onCancel: () => setIsOpenDeleteDialog(false), onSuccess: (_, message) => onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(message) })));
};
export default DocumentInfoDrawer;
//# sourceMappingURL=DocumentInfoDrawer.js.map